import React, { useEffect, useReducer } from 'react';
import { useLocation } from 'react-router';
import { DevTool } from '@hookform/devtools';
import { SetNewPasswordFieldNames, useSetNewPasswordForm } from 'hooks/forms';
import { useResetPassword } from 'hooks/api/changePassword';
import { useNavigate } from 'hooks/routes';
import { passwordVisibilityInitialData, passwordVisibilityReducer } from 'hooks/reducers';
import { protectEmailInState } from 'utils/typeGuards';
import Field from 'components/Field';
import Button from 'components/Button';
import SecureIcon from 'components/SecureIcon';
import PasswordRulesModal from 'components/PasswordRulesModal';
import styles from './SetNewPassword.module.css';
import messages from './SetNewPassword.messages';

export default function SetNewPassword() {
  const { state } = useLocation();
  const email = protectEmailInState(state) ? state.email : '';
  const { toLogin } = useNavigate();
  useEffect(() => {
    if (!state) toLogin();
  }, []);
  const {
    form,
    customState: { focusedField, isCompleted, onBlur, onFocus },
  } = useSetNewPasswordForm();
  const { mutateAsync: resetPassword, isLoading } = useResetPassword();

  const [passwordHidden, setPasswordHiding] = useReducer(
    passwordVisibilityReducer,
    passwordVisibilityInitialData,
  );

  const onSubmit = () => {
    const { newPassword } = form.getValues();
    resetPassword({ newPassword, email });
  };

  return (
    <div className={styles.setNewPassword}>
      <h1 className={styles.setNewPassword__title}>{messages.title}</h1>
      <p className={styles.setNewPassword__subtitle}>{messages.subtitle}</p>
      <DevTool control={form.control} />
      <form
        className={styles.setNewPassword__form}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <div className={styles.setNewPassword__modalWrapper}>
          <Field
            form={form}
            name={SetNewPasswordFieldNames.newPassword}
            placeholder={messages.placeholder.newPassword}
            onFocus={() => onFocus(SetNewPasswordFieldNames.newPassword)}
            onBlur={onBlur}
            className={styles.input}
            defaultValue={''}
            type={passwordHidden?.newPassword ? 'password' : 'text'}
            icon={
              <SecureIcon
                changeSecuredState={() => {
                  setPasswordHiding(SetNewPasswordFieldNames.newPassword);
                }}
              />
            }
          />
          <PasswordRulesModal
            control={form.control}
            name={SetNewPasswordFieldNames.newPassword}
            isShow={focusedField === SetNewPasswordFieldNames.newPassword}
          />
        </div>
        <div className={styles.setNewPassword__modalWrapper}>
          <Field
            form={form}
            name={SetNewPasswordFieldNames.repeatNewPassword}
            placeholder={messages.placeholder.repeatNewPassword}
            onFocus={() => onFocus(SetNewPasswordFieldNames.repeatNewPassword)}
            onBlur={onBlur}
            className={styles.input}
            defaultValue={''}
            type={passwordHidden?.repeatNewPassword ? 'password' : 'text'}
            icon={
              <SecureIcon
                changeSecuredState={() => {
                  setPasswordHiding(SetNewPasswordFieldNames.repeatNewPassword);
                }}
              />
            }
          />
          <PasswordRulesModal
            control={form.control}
            name={SetNewPasswordFieldNames.repeatNewPassword}
            isShow={focusedField === SetNewPasswordFieldNames.repeatNewPassword}
          />
        </div>
        <Button
          type={'submit'}
          displayDisabledUI={!isCompleted}
          isLoading={isLoading}
          className={styles.setNewPassword__button}
        >
          {messages.confirmButton}
        </Button>
      </form>
    </div>
  );
}
